import { ChevronDown, Pencil } from 'lucide-react'
import type { ComponentProps, ReactNode } from 'react'

import { cn } from '@/utils'

type StatementFieldName = 'account' | 'dates'

// The rest of a button's props pass through, so a popover trigger can drive it.
interface StatementFieldProps extends ComponentProps<'button'> {
  field: StatementFieldName
  missing: boolean
  title: string
  children: ReactNode
}

// The two things a statement is filed by. They are drawn as controls at rest, because as bare
// text nobody could tell the dates were theirs to correct without hovering them first.
export const StatementField = ({
  field,
  missing,
  title,
  children,
  ...buttonProps
}: StatementFieldProps) => (
  <button
    type="button"
    data-statement-field={field}
    title={title}
    {...buttonProps}
    className={cn(
      'flex h-7 cursor-pointer items-center gap-1.5 rounded-md border bg-white px-2 text-[13px] font-medium transition-colors hover:bg-accent',
      missing ? 'border-amber-300 text-amber-700' : 'text-foreground',
    )}
  >
    {children}
    {field === 'account' ? (
      <ChevronDown className="size-3.5 shrink-0 text-ink-subtle" />
    ) : (
      <Pencil className="size-3 shrink-0 text-ink-subtle" />
    )}
  </button>
)
